import { getVipTypeById, getVipTypeByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { updateCert } from "@/services";
import { useCallback, useRef, useState } from "react";
import HBMessage from "../HBMessage";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import SubjectConfirm from "../Vip/subjectConfirm";
import AuthSubject from "./form";
import styles from "./index.module.less";

/**
 *
 * @param {{
 *    vipId?: string,
 *    certSubject?: CERTSubject,
 *    onOk?: Function,
 *    onCancel?: Function,
 * } & Partial<Parameters<AuthSubject>[0]> & import("antd").ModalProps} param
 * @returns
 */
function Dialog({ vipId, certSubject, onOk, onCancel, ...props }) {
  const [step, setStep] = useState(0);
  const subject = useRef(certSubject?.subject_info || {});

  const user = useAppStore((store) => store.user);

  let currentVipType = getVipTypeByUser(user);

  // 当有vipId时，根据vipId获取vipType， user信息更新不及时
  if (vipId) {
    currentVipType = getVipTypeById(vipId);
  }

  const vipType =
    currentVipType === "company" || currentVipType === "bigCompany"
      ? "company"
      : "personal";

  const onSubmit = useCallback(async (data) => {
    subject.current = data;
    setStep(1);
  }, []);

  const onConfirm = useCallback(async () => {
    const result = await updateCert({
      id: certSubject.id,
      subject: subject.current,
    });

    if (result.err) return;

    HBMessage.success("提交成功");
    onOk && onOk();
  }, [certSubject.id, onOk]);

  return (
    <HBModal
      title={step === 0 ? "填写被授权方" : "授权信息确认"}
      width={580}
      wrapClassName={styles.modal}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      {step === 0 ? (
        <AuthSubject
          initValue={subject.current}
          type={vipType}
          onSubmit={onSubmit}
          onCancel={onCancel}
          footerStyle={{
            justifyContent: "flex-end",
            paddingBottom: 24,
          }}
        />
      ) : (
        // 因为临时提的要有确认信息，所以这个组件不在同一文件夹内
        <SubjectConfirm
          noTitle
          width={420}
          subject={subject.current}
          onOk={onConfirm}
          onBack={() => {
            setStep(0);
          }}
          footerStyle={{
            justifyContent: "flex-end",
            margin: "24px 0",
          }}
        />
      )}
    </HBModal>
  );
}

const AuthSubjectDialog = ModalWrap(Dialog);

export default AuthSubjectDialog;
